import script from "./FileShare.vue?vue&type=script&setup=true&lang=js"
export * from "./FileShare.vue?vue&type=script&setup=true&lang=js"

import "./FileShare.vue?vue&type=style&index=0&id=311d0511&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-311d0511"]])

export default __exports__